//
export default {
    name: "r-dashboard-toolbar",
    computed: {

        /**
         * 
         */
        toolbarProps () {
            return {
                class   : this.color,
                flat    : ! this.scrollY && this.withScroll
            }
        }
    },
    data () {
        return {
            scrollY: 0,
        }
    },
    methods: {

        /**
         * 
         */
        scrolled () {
            this.scrollY = window.scrollY
        }
    },
    props: {

        /**
         * 
         */
        color: {
            type: String,
            default: "indigo darken-4",
        },

        /**
         * 
         */
        title: {
            type: String,
            default: "TITLE",
        },

        /**
         * 
         */
        withScroll: {
            type: Boolean,
            default: true,
        },
    },
    created () {
        window.addEventListener( "scroll", this.scrolled )
    },
}